import {Badge} from "@mui/material";
import {Table, Button, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {MdEmail, MdPhone} from "react-icons/md";
import VouchersFindRedeemButton from "./VouchersFindRedeemButton";
import moment from "moment/moment";
import * as React from "react";

/*
* This component is used by VouchersFind.js
* @param {array} dataTbl - the data to display
* @param {string} searchTerm - the search term
* @param {function} setCurrentRow - the function to set the current row
* @param {function} setShowModal - the function to set the show modal
 */
export default function VouchersFindShowTable ({dataTbl,searchTerm,setCurrentRow,setShowModal}) {
        // Use a moment object for now (with offset) so we can compare to expiry + 6 months
        const now = moment().utcOffset("+12:00");
    if(searchTerm==='') return null;

    return (
        <>
            <div style={{margin:'20px 0'}}>
                {dataTbl.length} Records found.
            </div>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Voucher #</TableCell>
                        <TableCell>Applicant fee</TableCell>
                        <TableCell align="left">Owner details</TableCell>
                        <TableCell align="left">Voucher issued</TableCell>
                        <TableCell align="left">Animal details</TableCell>
                        <TableCell align="right">&nbsp;</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dataTbl.map((row,idx) => {
                        return (
                            <TableRow key={idx}>
                                <TableCell align="left">
                                    {row.sn}
                                    {
                                        (row.sn_duplicate !== null && row.sn_duplicate !== '' && row.sn_duplicate !== row.sn) ?
                                            <div style={{color:'red', fontWeight:'bold'}}>This voucher number has changed. The number the client presents is {row.sn_duplicate}.</div>
                                            : undefined
                                    }
                                </TableCell>
                                <TableCell align="left" style={{whiteSpace:'nowrap'}}>
                                    {
                                        (
                                            (row.sponsor_id > 0 && row.sponsor_applicant_cost > 0 && row.sponsor_microchip_extra_cost > -999)
                                            || ['community','inspectors','outreach'].includes(row.campaign_target)
                                        ) ?
                                            <span style={{color:'red'}}>No client fee</span>
                                            :
                                            <span style={{opacity:0.3}}>Client pays fee.</span>
                                    }
                                </TableCell>
                                <TableCell align="left">
                                    <b>
                                        {(row.is_redeemed > 0) ? row.owner_first :  row.first}&nbsp;
                                        {(row.is_redeemed > 0) ? row.owner_last :  row.last}
                                    </b><br/>
                                    <span style={{whiteSpace: 'nowrap'}}><MdEmail/> <a href={"mailto:" + (row.is_redeemed > 0) ? row.owner_email :  row.email}
                                                                                       target={"_blank"} rel={"noreferrer"}>{(row.is_redeemed > 0) ? row.owner_email :  row.email}</a></span><br/>
                                    <span style={{whiteSpace: 'nowrap'}}><MdPhone/> {(row.is_redeemed > 0) ? row.owner_phone :  row.phone}</span>
                                </TableCell>
                                <TableCell align="left">{new Date(row.created_at).toLocaleDateString('en-NZ')}</TableCell>
                                <TableCell align="left">
                                    <div>
                                        {row.a_microchip_only_flag > 0 ? <p style={{marginTop: 0, color:'red'}}>Microchip only</p> : undefined}
                                    </div>
                                    <div style={{display:'flex', flex:'1 0 100%', flexWrap:'wrap'}}>
                                        <button className={"vet-info-button"}>
                    {row.campaign_target !== 'community' && row.campaign_target !== 'inspectors' && row.campaign_target !== 'outreach' && "Public"}
                    {row.campaign_target === 'community' && "Community"}
                    {row.campaign_target === 'inspectors' && "Inspector"}
                    {row.campaign_target === 'outreach' && "Outreach"}
                </button>
                                        <button className={"vet-info-button"}>Name {row.a_name}:</button>
                                        <button className={"vet-info-button"}>Type: {row.a_type}</button>
                                        <button className={"vet-info-button"}>Sex: {row.a_gender}</button>
                                        <button className={"vet-info-button"}>Age: {row.a_age}</button>
                                        <button className={"vet-info-button"}>Primary color: {row.a_color_primary}</button>
                                        {(row.a_color_secondary !== '') ? <button className={"vet-info-button"}>Secondary color: {row.a_color_secondary}</button> : undefined}
                                        <button className={"vet-info-button"}>Microchipped: {(row.a_microchipped > 0) ? "Yes" : "No"}</button>
                                        <button className={"vet-info-button"}>Is pregnant: {(row.a_is_pregnant > 0) ? "Yes" : "No"}</button>
                                        <button className={"vet-info-button"}>Was pregnant in the last 6 weeks: {(row.a_was_pregnant > 0) ? "Yes" : "No"}</button>
                                    </div>
                                </TableCell>
                                <TableCell align="right">
    { row.is_cancelled === 1 ? (
      <Button
        variant="contained"
        disabled
        sx={{ backgroundColor: 'red', color: 'white' }}
      >
        Cancelled
      </Button>
    ) : (now.isAfter(moment(row.expiry_date).add(6, 'months')) && !(row.is_redeemed > 0)) ? (
      <Button
        variant="contained"
        disabled
        sx={{ backgroundColor: 'grey', color: 'white' }}
      >
        Expired
      </Button>
    ) : (
      <VouchersFindRedeemButton
        row={row}
        setCurrentRow={setCurrentRow}
        setShowModal={setShowModal}
      />
    )
  }
</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </>
    )
}
